import React, { useState, useMemo, useEffect } from 'react';
import { format } from 'date-fns';
import { useParams } from 'react-router-dom';
import { ptBR } from 'date-fns/locale';
import { Container, Box, Button } from '@material-ui/core/';

import { isValid } from 'date-fns/esm';
import { Typography } from '@material-ui/core';
import TableRegister from '../../components/TableRegister';
import MapMarker from '../../components/MapMarker';
import api from '../../services/api';
import { useStyles } from './style';
import {
  Tests,
  Positive,
  CarsMoto,
  MissionDetails,
  NoticeDetails,
  InfractionsVehicles,
  Comment,
  SurveillanceMission,
  Agent,
  Refusa,
  ViaDetails,
  DRV,
  Coordinator,
} from '../../@types/surveilanceTypes';
import { fetchSurveillanceById } from '../../actions/surveillanceActions';
import { SurveilanceType } from '../../@types/surveilanceTypes';
import { Register } from '../../@types/surveilanceTypes'


interface routeParams {
  pathId: string;
}

const RegisterSurveillance: React.FC = () => {
  const styles = useStyles();

  const {pathId} = useParams<routeParams>();

  const [active, setActive] = useState<number>(0);
  const [variant, setVariant] = useState<'text' | 'outlined' | 'contained' | undefined>(
    'text',
  );

  const [tests, setTests] = useState<Tests>({
    Alcoolsensor: '',
    Passivos: '',
    _localId: '',
  });
  const [positive, setPositive] = useState<Positive>({
    'Total de Positivos Masculino': '',
    'Total de Positivos Feminino': '',
    _localId: '',
  });
  const [carsMoto, setCarsMoto] = useState<CarsMoto[]>([]);
  const [missionDetails, setMissionDetails] = useState<MissionDetails>({
    'Quantidade de Veículos 4+ Rodas Removidos (Pela AMC ou pelo Proprietário)': '',
    'Quantidade de Motocicletas, Ciclomotores e Triciclos Abordados': '',
    'Quantidade de Veículos de 2 ou 3 Rodas Removidos (Pela AMC ou pelo Proprietário)':
      '',
    'Quantidade de Habilitações Recolhidas': '',
    'Total de Veículos Abordados': '',
    'Equipe de Apoio': '',
    'Quantidade de Veículos com mais de 3 Rodas Abordados': '',
    _localId: '',
    'Quantidade de CRLVs Recolhidos': '',
  });
  const [noticeDetails, setNoticeDetails] = useState<NoticeDetails[]>([]);
  const [infractionsVehicles, setInfractionsVehicles] = useState<InfractionsVehicles>({
    'Total de Infrações': '',
    'Total de Veículos Autuados': '',
    _localId: '',
  });
  const [comment, setComment] = useState<Comment>({
    Observações: '',
    _localId: '',
  });
  const [surveillanceMission, setSurveillanceMission] = useState<SurveillanceMission>({
    'Descrição do tipo da Missão': '',
    'Descrição do Foco da Missão': '',
    'Foco da Missão': '',
    'Tipo da Missão': '',
    _localId: '',
  });
  const [agent, setAgent] = useState<Agent[]>([]);
  const [refusa, setRefusa] = useState<Refusa>({
    'Total de Recusas Feminino': '',
    'Total de Recusas Masculino': '',
    _localId: '',
  });
  const [viaDetails, setViaDetails] = useState<ViaDetails[]>([]);
  const [drvs, setDrvs] = useState<DRV[]>([]);
  const [coordinator, setCoordinator] = useState<Coordinator[]>([]);

  const [register, setRegister] = useState<Register>({
    uuid: '',
    data: {
      testsPerformedOrStartedCount: tests,
      positiveAmount: positive,
      carsOrMotocycles: carsMoto,
      surveillanceMissionDetails: missionDetails,
      noticesDetails: noticeDetails,
      infractionsAndNoticedVehiclesAmount: infractionsVehicles,
      comments: comment,
      driverSurveillanceMission: surveillanceMission,
      agentRegisters: agent,
      refusalAmount: refusa,
      viaDetails,
      DRVsNumber: drvs,
      missionCoordinator: coordinator,
    },
    occurred_from: '',
    occurred_to: '',
    geom: {
      coordinates: [0, 0],
    },
    location_text: '',
  });

  const authHeader = useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);

  useEffect(() => {
    async function loadRegister(id: string) {
      const registers = await fetchSurveillanceById(id);
      setRegister(registers.data);
    }
    loadRegister(pathId);
  }, [pathId, authHeader]);

  const toDate = (date: string): String => {
    if (isValid(new Date(date))) {
      const newDate = format(new Date(date), 'dd MMMM, yyyy, HH:mm:ss', {
        locale: ptBR,
      });
      return newDate;
    }
    return '';
  };

  return (
    <Container className={styles.container}>
      <Box className={styles.box}>
        <Button
          variant={variant}
          className={`${styles.buttons} ${active === 0 ? styles.buttonActive : ''}`}
          onClick={() => {
            setActive(0);
          }}
        >
          Detalhes da Fiscalização
        </Button>
        <Button
          variant={variant}
          className={`${styles.buttons} ${active === 1 ? styles.buttonActive : ''}`}
          onClick={() => {
            setActive(1);
          }}
        >
          Códigos
        </Button>
        <Button
          variant={variant}
          className={`${styles.buttons} ${active === 2 ? styles.buttonActive : ''}`}
          onClick={() => {
            setActive(2);
          }}
        >
          Agentes
        </Button>
      </Box>

      {active === 0 && (
        <>
          <Container className={styles.root}>
            <TableRegister
              title={['tipo da missão', 'foco da missão']}
              data={[
                {
                  details: [
                    `${register.data.driverSurveillanceMission?.['Tipo da Missão']}`,
                    `${register.data.driverSurveillanceMission?.['Foco da Missão']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['descrição do tipo da missão', 'descrição do foco da missão']}
              data={[
                {
                  details: [
                    `${register.data.driverSurveillanceMission?.['Descrição do tipo da Missão']}`,
                    `${register.data.driverSurveillanceMission?.['Descrição do Foco da Missão']}`,
                  ],
                },
              ]}
            />
            <Container className={styles.containerMap}>
              <MapMarker
                point={[register.geom.coordinates[1], register.geom.coordinates[0]]}
                notDragabble
              />
            </Container>
            <TableRegister
              title={['endereço']}
              data={[
                {
                  details: [
                    `${register.location_text}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['latitude', 'longitude']}
              data={[
                {
                  details: [
                    `${register.geom.coordinates[1]}`,
                    `${register.geom.coordinates[0]}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['data e hora da solicitação', 'data e hora do fim']}
              data={[
                {
                  details: [
                    `${toDate(register?.occurred_from)}`,
                    `${toDate(register?.occurred_to)}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={[
                'equipe de apoio',
                'quantidade de veículos com mais de 3 rodas abordados',
              ]}
              data={[
                {
                  details: [
                    `${register.data.surveillanceMissionDetails?.['Equipe de Apoio']}`,
                    `${register.data.surveillanceMissionDetails?.['Quantidade de Veículos com mais de 3 Rodas Abordados']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={[
                'quantidade de motocicletas, ciclomotores e triciclos abordados',
                'total de veículos abordados',
              ]}
              data={[
                {
                  details: [
                    `${register.data.surveillanceMissionDetails?.['Quantidade de Motocicletas, Ciclomotores e Triciclos Abordados']}`,
                    `${register.data.surveillanceMissionDetails?.['Total de Veículos Abordados']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={[
                'quantidade de veículos 4+ rodas removidos',
                'quantidade de veículos 2 ou 3 rodas removidos',
              ]}
              data={[
                {
                  details: [
                    `${register.data.surveillanceMissionDetails?.['Quantidade de Veículos 4+ Rodas Removidos (Pela AMC ou pelo Proprietário)']}`,
                    `${register.data.surveillanceMissionDetails?.['Quantidade de Veículos de 2 ou 3 Rodas Removidos (Pela AMC ou pelo Proprietário)']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={[
                'quantidade de crlvs recolhidos',
                'quantidade de habilitações recolhidas',
              ]}
              data={[
                {
                  details: [
                    `${register.data.surveillanceMissionDetails?.['Quantidade de CRLVs Recolhidos']}`,
                    `${register.data.surveillanceMissionDetails?.['Quantidade de Habilitações Recolhidas']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={[
                'quantidade de testes realizados ou iniciados passivos',
                'quantidade de testes realizados ou iniciados alcoolsensor',
              ]}
              data={[
                {
                  details: [
                    `${register.data.testsPerformedOrStartedCount?.Passivos}`,
                    `${register.data.testsPerformedOrStartedCount?.Alcoolsensor}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['total de recusas masculino', 'total de recusas feminino']}
              data={[
                {
                  details: [
                    `${register.data.refusalAmount?.['Total de Recusas Masculino']}`,
                    `${register.data.refusalAmount?.['Total de Recusas Feminino']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['total de positivos masculino', 'total de positivos feminino']}
              data={[
                {
                  details: [
                    `${register.data.positiveAmount?.['Total de Positivos Masculino']}`,
                    `${register.data.positiveAmount?.['Total de Positivos Feminino']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['total de infrações', 'total de veículos autuados']}
              data={[
                {
                  details: [
                    `${register.data.infractionsAndNoticedVehiclesAmount?.['Total de Infrações']}`,
                    `${register.data.infractionsAndNoticedVehiclesAmount?.['Total de Veículos Autuados']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['observações/descrição']}
              data={[
                {
                  details: [`${register.data.comments?.Observações}`],
                },
              ]}
            />
          </Container>

          <Container className={styles.small}>
            <TableRegister
              title={['tipo da missão']}
              data={[
                {
                  details: [
                    `${register.data.driverSurveillanceMission?.['Tipo da Missão']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['descrição do tipo da missão']}
              data={[
                {
                  details: [
                    `${register.data.driverSurveillanceMission?.['Descrição do tipo da Missão']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['foco da missão']}
              data={[
                {
                  details: [
                    `${register.data.driverSurveillanceMission?.['Foco da Missão']}`,
                  ],
                },
              ]}
            />

            <TableRegister
              title={['descrição do foco da missão']}
              data={[
                {
                  details: [
                    `${register.data.driverSurveillanceMission?.['Descrição do Foco da Missão']}`,
                  ],
                },
              ]}
            />
            <Container className={styles.containerMap}>
              <MapMarker
                point={[register.geom.coordinates[1], register.geom.coordinates[0]]}
                notDragabble
              />
            </Container>

            <TableRegister
              title={['latitude']}
              data={[
                {
                  details: [`${register.geom.coordinates[1]}`],
                },
              ]}
            />
            <TableRegister
              title={['longitude']}
              data={[
                {
                  details: [`${register.geom.coordinates[0]}`],
                },
              ]}
            />
            <TableRegister
              title={['data e hora da solicitação']}
              data={[
                {
                  details: [`${register?.occurred_from}`],
                },
              ]}
            />
            <TableRegister
              title={['data e hora do fim']}
              data={[
                {
                  details: [`${register?.occurred_to}`],
                },
              ]}
            />
            <TableRegister
              title={['equipe de apoio']}
              data={[
                {
                  details: [
                    `${register.data.surveillanceMissionDetails?.['Equipe de Apoio']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['quantidade de veículos com mais de 3 rodas abordados']}
              data={[
                {
                  details: [
                    `${register.data.surveillanceMissionDetails?.['Quantidade de Veículos com mais de 3 Rodas Abordados']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['quantidade de motocicletas, ciclomotores e triciclos abordados']}
              data={[
                {
                  details: [
                    `${register.data.surveillanceMissionDetails?.['Quantidade de Motocicletas, Ciclomotores e Triciclos Abordados']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['total de veículos abordados']}
              data={[
                {
                  details: [
                    `${register.data.surveillanceMissionDetails?.['Total de Veículos Abordados']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['quantidade de veículos 3+ rodas removidos']}
              data={[
                {
                  details: [
                    `${register.data.surveillanceMissionDetails?.['Quantidade de Veículos 4+ Rodas Removidos (Pela AMC ou pelo Proprietário)']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['quantidade de veículos 2 ou 3 rodas removidos']}
              data={[
                {
                  details: [
                    `${register.data.surveillanceMissionDetails?.['Quantidade de Veículos de 2 ou 3 Rodas Removidos (Pela AMC ou pelo Proprietário)']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['quantidade de crlvs recolhidos']}
              data={[
                {
                  details: [
                    `${register.data.surveillanceMissionDetails?.['Quantidade de CRLVs Recolhidos']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['quantidade de habilitações recolhidas']}
              data={[
                {
                  details: [
                    `${register.data.surveillanceMissionDetails?.['Quantidade de Habilitações Recolhidas']}`,
                  ],
                },
              ]}
            />

            <TableRegister
              title={['quantidade de testes realizados ou iniciados passivos']}
              data={[
                {
                  details: [`${register.data.testsPerformedOrStartedCount?.Passivos}`],
                },
              ]}
            />
            <TableRegister
              title={['quantidade de testes realizados ou iniciados alcoolsensor']}
              data={[
                {
                  details: [
                    `${register.data.testsPerformedOrStartedCount?.Alcoolsensor}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['total de recusas masculino']}
              data={[
                {
                  details: [
                    `${register.data.refusalAmount?.['Total de Recusas Masculino']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['total de recusas feminino']}
              data={[
                {
                  details: [
                    `${register.data.refusalAmount?.['Total de Recusas Feminino']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['total de positivos masculino']}
              data={[
                {
                  details: [
                    `${register.data.positiveAmount?.['Total de Positivos Masculino']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['total de positivos feminino']}
              data={[
                {
                  details: [
                    `${register.data.positiveAmount?.['Total de Positivos Feminino']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['total de infrações']}
              data={[
                {
                  details: [
                    `${register.data.infractionsAndNoticedVehiclesAmount?.['Total de Infrações']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['total de veículos autuados']}
              data={[
                {
                  details: [
                    `${register.data.infractionsAndNoticedVehiclesAmount?.['Total de Veículos Autuados']}`,
                  ],
                },
              ]}
            />
            <TableRegister
              title={['observações/descrição']}
              data={[
                {
                  details: [`${register.data.comments?.Observações}`],
                },
              ]}
            />
          </Container>
        </>
      )}

      {active === 1 && (
        <Container className={styles.showAll}>
          <TableRegister title={['MATRÍCULA COORDENADOR DA MISSÃO']} />
          {register.data?.missionCoordinator.map((coordenador) => (
            <TableRegister
              key={`${coordenador}`}
              data={[
                {
                  details: [`${coordenador?.Matrícula}`],
                },
              ]}
            />
          ))}
          <TableRegister title={['MATRÍCULA AGENTE']} />
          {register.data?.agentRegisters.map((agente) => (
            <TableRegister
              key={`${agente}`}
              data={[
                {
                  details: [`${agente?.Matrícula}`],
                },
              ]}
            />
          ))}
          <TableRegister title={['CÓDIGO DA VIATURA']} />
          {register.data?.carsOrMotocycles.map((viatura) => (
            <TableRegister
              key={`${viatura}`}
              data={[
                {
                  details: [`${viatura?.Número}`],
                },
              ]}
            />
          ))}
          <TableRegister title={['NÚMERO DO DRV']} />
          {register.data?.DRVsNumber.map((drv) => (
            <TableRegister
              key={`${drv}`}
              data={[
                {
                  details: [`${drv?.Número}`],
                },
              ]}
            />
          ))}
        </Container>
      )}
      {active === 2 && (
        <>
          <Container className={styles.root}>
            <TableRegister title={['ENQUADRAMENTO', 'QUANTIDADE']} />
            {register.data?.noticesDetails.map((autuacoes) => (
              <TableRegister
                key={`${autuacoes?.Enquadramento}${autuacoes?.Quantidade}`}
                data={[
                  {
                    details: [`${autuacoes?.Enquadramento}`, `${autuacoes?.Quantidade}`],
                  },
                ]}
              />
            ))}
          </Container>
          <Container className={styles.small}>
            {register.data?.noticesDetails.map((autuacoes) => (
              <>
                <Typography style={{ margin: '2% 0 2% 0', fontWeight: 'bold' }}>
                  {register.data?.noticesDetails.indexOf(autuacoes) + 1} de{' '}
                  {register.data?.noticesDetails.length}
                </Typography>
                <TableRegister
                  title={['enquadramento']}
                  key={`${autuacoes?.Enquadramento}${autuacoes?.Quantidade}`}
                />
                <TableRegister
                  data={[
                    {
                      details: [`${autuacoes?.Enquadramento}`],
                    },
                  ]}
                />
                <TableRegister title={['quantidade']} />
                <TableRegister
                  data={[
                    {
                      details: [`${autuacoes?.Quantidade}`],
                    },
                  ]}
                />
              </>
            ))}
          </Container>
        </>
      )}
    </Container>
  );
};

export default RegisterSurveillance;
